/**
 * Empty-state placeholder for lists that returned zero rows.
 *
 * Tailwind utilities only — no class soup. Pair with a hint that tells
 * the user what action would populate the list.
 */
import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  hint?: ReactNode;
}

export function EmptyState({ title, hint }: EmptyStateProps): React.ReactElement {
  return (
    <div
      className="text-center py-8 px-4 rounded-[14px]"
      style={{ background: "var(--color-secondary-bg)" }}
      role="status"
    >
      <p className="text-[13px] font-medium">{title}</p>
      {hint ? (
        <p
          className="text-[12px] mt-1 leading-snug"
          style={{ color: "var(--color-hint)" }}
        >
          {hint}
        </p>
      ) : null}
    </div>
  );
}
